import React from "react";
import { View, StyleSheet } from "react-native";
import { TGetMessagesResponse } from "../../../../services/api-clinic";
import MessageThreadPatientInfo from "./MessageThreadPatientInfo";
import MessageThreadReply from "./MessageThreadReply";
import MessageThreadTexts from "./MessageThreadTexts";

type MessageThreadProps = {
  messageThread: TGetMessagesResponse;
  fetchLatestMessageThread: (
    patientUuid: string,
    conversationId: number,
  ) => void;
};

const MessageThread: React.FC<MessageThreadProps> = ({
  messageThread,
  fetchLatestMessageThread,
}) => {
  return (
    <View style={styles.container1}>
      <View style={styles.container}>
        <MessageThreadPatientInfo
          patientData={messageThread.patient_info}
          patientImages={messageThread.patient_info_thumbnail_urls}
          patientImagesOriginalSize={messageThread.patient_info_image_urls}
        />
      </View>
      <MessageThreadTexts messages={messageThread.messages} />
      <MessageThreadReply
        patientUuid={messageThread.patient_info.uuid}
        aiResponse={
          messageThread.messages.find((msg) => msg.ai_response)?.ai_response ??
          ""
        }
        fetchLatestMessageThread={fetchLatestMessageThread}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container1: {
    flex: 1,
    flexDirection: "column",
    gap: 10,
  },
  container: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  titleContainer: {},
  text: {
    fontSize: 16,
    fontFamily: "Urbanist500",
  },
  badge: {},
  checkboxContainer: {
    flexDirection: "row",
  },
});

export default MessageThread;
